export enum EbLocalStorageKey {
  AUTH_KEY = 'spartacus⚿⚿auth',
  LANG_KEY = 'spartacus⚿⚿language',
  COUNTRY_KEY = 'spartacus⚿⚿country',
  CONSENT_KEY = 'spartacus⚿⚿anonymous-consents',
  CURRENCY_KEY = 'spartacus⚿⚿currency',
  ASM_KEY = 'spartacus⚿⚿asm'
}
